'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/~/chart.js/src/charts/Chart.Doughnut.js
// module id = 1502
// module chunks = 21